import { Icon, SvgPause, SvgPlay } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function PlayPauseButton(props) {
  const hoverTagText = props.paused ? 'Play (k)' : 'Pause (k)';

  return (
    <ControlBarButton
      className="video-player-play-button"
      hoverTagText={hoverTagText}
      seeking={props.seeking}
      onClick={props.onClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={props.paused ? <SvgPlay /> : <SvgPause />}
      />
    </ControlBarButton>
  );
}
